import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Alert, Form, DatePicker, Space, Typography, Row, Col, TimePicker } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { POST } from '../../utils/HttpClient';
import { Toast } from '../../utils/Toast';
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from '../../constance/strings';
import Title from 'antd/es/typography/Title';
import dayjs from 'dayjs';

export default function SyncDataModal(props) {

  const {
    url,
    title,
    content,
    open,
    onClose,
  } = props;

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const date = Form.useWatch('date', form);
  const start_time = Form.useWatch('start_time', form);
  const end_time = Form.useWatch('end_time', form);

  const handleSubmit = async () => {
    setIsLoading(true);
    setErrorMessages(null);
    try {
      const value = await form.validateFields();

      const updateValues = {
        date: dayjs(date).format(DATE_FORMAT),
        start_time: dayjs(start_time).format('HH:mm'),
        end_time: dayjs(end_time).format('HH:mm')
      }

      await POST(url, updateValues)
      Toast.success(t('success'))
      onClose();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false);
    }
  }

  React.useEffect(() => {
    if (open) {
      form.resetFields();
      setErrorMessages(null);
    }
  }, [open])

  return (
    <div>
      <Modal
        open={open}
        onCancel={onClose}
        title={<Title level={4}>{title}</Title>}
        footer={[
          <Button type='primary' loading={isLoading} icon={<CheckOutlined />} onClick={handleSubmit}>
            {t('confirm')}
          </Button>,
          <Button loading={isLoading} icon={<CloseOutlined />} onClick={onClose}>
            {t('cancel')}
          </Button>]}>
        <Space direction='vertical'>
          {errorMessages && <Alert type="error" message={errorMessages} />}
          <Typography.Text strong>{content}</Typography.Text>
          <Form form={form}>
            <Row>
              <Col sm={24} md={12} lg={12} style={{ width: '100%' }}>
                <Form.Item
                  label={t('searchs.fields.date')}
                  name={'date'}
                  rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                  <DatePicker
                    placeholder={t('searchs.placeholders.date')}
                    format={HUMAN_DATE_FORMAT}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col sm={24} md={12} lg={12} style={{ width: '100%' }} >
                <Form.Item
                  label='ตั้งแต่เวลา' name={'start_time'}
                  rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                  <TimePicker placeholder="--" format={'HH:mm'} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col sm={24} md={12} lg={12} style={{ width: '100%' }}>
                <Form.Item
                  label='ถึงเวลา' name={'end_time'}
                  rules={[{ required: true, message: t('error_messages.validation.required') }]}>
                  <TimePicker placeholder="--" format={'HH:mm'} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Space>
      </Modal>
    </div>
  )
}